import React from 'react';
import {AuthContext} from "@/provider/auth/authContext";

export const useAuth = () => React.useContext(AuthContext);